import './ccf-check-box-outline-blank-icon.module.scss';
import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCheckBoxOutlineBlankIconProps  {}
/**
 * component used to display checckbox icon without outline
 * @param props - CcfCheckBoxOutlineBlankIconProps
 * @example - <CcfCheckBoxOutlineBlankIcon />
 * @returns SVG of checkbox outline blank icon
 */
export function CcfCheckBoxOutlineBlankIcon(
  props: CcfCheckBoxOutlineBlankIconProps
) {
  return (
    <SvgIcon {...props}>
      <rect
        x="3.5"
        y="3.5"
        width="17"
        height="17"
        rx="1.5"
        fill="white"
        stroke="#dae2e8"
      />
    </SvgIcon>
  );
}

export default CcfCheckBoxOutlineBlankIcon;
